import { useState, useEffect } from 'react';
import { getHotArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import type { Article } from '@/mocks/articles';

export default function PopularArticles() {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setArticles(getHotArticles());
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <section className="w-full px-4 md:px-6 py-12 bg-background-900/50">
        <div className="max-w-7xl mx-auto">
          <div className="animate-pulse space-y-6">
            <div className="h-8 w-48 bg-background-800 rounded"></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1,2,3].map((i) => (
                <div key={i} className="h-80 bg-background-800 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full px-4 md:px-6 py-12 bg-background-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl font-bold text-foreground-100" style={{ fontFamily: "var(--font-heading)" }}>
            <i className="ri-fire-line text-accent-400 mr-2"></i>
            热门追踪
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}